export class MakePaymentRequest {
  reference: string;
  userId: string;
  amount: number;
  currency: string;
  bankCode: string;
  bankAccount: string;
  bankAccountName: string;
  oneTime: boolean;
  paymentChannel: string;
  provider: string;
  callbackUrl: string;
  narration: string;
  callbackMode: string;
  metadata: string;
}

export class PaymentPageReq {
  reference: string;
  pageName: string;
  narration: string;
  customLink: string;
  currency:string;
  metaData: {
    name: string;
    lineItem: [{ itemName: string; itemCode: string; itemAmount: string }];
  };
}

export class PaymentPageRes {
  reference: string;
  pageName: string;
  narration: string;
  metaData: {
    name: string;
    lineItem: [{ itemName: string; itemCode: string; itemAmount: string }];
  };
  customLink: string;
  active: boolean;
  saveCustomerDetails: boolean;
  allowPartialPayment: boolean;
  scheduleType: string;
  scheduleFrequencyDays: number;
  lastUpdatedAt: string;
}

export class MakePaymentResponse {
  clientId: string;
  paymentUrl: string;
  reference: string;
  status: string;
}

export class CreatePaymentRequest {
  reference: string;
  userId: string;
  amount: number;
  currency: string;
  callbackUrl: string;
}
